import { NewsOrigin } from '../shared/enum/NewsOrigin';

export interface InfluencerSpreadsheetModel {
    id: number,
    id_planilha:number,
    clientId: number,
    clientDescription: string, 
    clipperId: number,
    clipperDescription: string, 
    creationDate: Date,
    statusNews: string,
    totalInfluencer:  number,
    fileDescription: string,
    classificado: number,
    totalNews: number,
    newsOrigin: NewsOrigin | null
    autorizado:number,
}

export const InfluencerSpreadsheetModelInitial: InfluencerSpreadsheetModel = {
    id: 0,
    id_planilha: 0,
    clientId: 0,
    clientDescription: '', 
    clipperId: 0,
    clipperDescription: '', 
    creationDate: new Date(),
    statusNews: '',
    fileDescription: '',
    classificado: 0,
    totalNews: 0,
    totalInfluencer:  0,
    autorizado:0,
    newsOrigin: null
};